export default __webpack_public_path__ + "static/media/heart-red.30e01b77.svg";